import {
  AbstractControl,
  FormGroup,
  FormControl,
  FormArray,
  ValidationErrors,
} from '@angular/forms';

interface InvalidControlInfo {
  path: string;
  errors: ValidationErrors | null;
}

export function collectInvalidControls(
  control: AbstractControl,
  parentPath: string = '',
  result: InvalidControlInfo[] = [],
): InvalidControlInfo[] {
  if (control instanceof FormControl) {
    if (control.invalid) {
      control.markAsDirty({ onlySelf: true });

      result.push({
        path: parentPath,
        errors: control.errors,
      });
    }
    return result;
  }

  if (control instanceof FormGroup) {
    Object.keys(control.controls).forEach((key) => {
      const child = control.controls[key];
      const path = parentPath ? `${parentPath}.${key}` : key;

      collectInvalidControls(child, path, result);
    });
  }

  if (control instanceof FormArray) {
    control.controls.forEach((child, index) => {
      const path = `${parentPath}[${index}]`;
      collectInvalidControls(child, path, result);
    });
  }

  return result;
}
